document.addEventListener("DOMContentLoaded", () => {

    const featured = document.getElementById("NiniFeaturedImage");
    const modal = document.getElementById("NiniGalleryModal");
    const track = document.getElementById("NiniModalTrack");

    const closeBtn = document.querySelector(".nini-modal__close");
    const prevBtn = document.querySelector(".nini-modal__prev");
    const nextBtn = document.querySelector(".nini-modal__next");

    if (!featured || !modal || !track) return;

    // ----------------------------------
    // Build Gallery
    // ----------------------------------

    const thumbs = [...document.querySelectorAll(".nini-thumb")];

    const gallery = thumbs.map((thumb) => ({
        src: thumb.dataset.image,
        alt: thumb.dataset.alt
    }));

    // Build Slides Once

    track.innerHTML = gallery.map(image => `
        <div class="nini-modal__slide">
            <img src="${image.src}" alt="${image.alt}">
        </div>
    `).join("");

    let currentIndex = 0;

    // ----------------------------------
    // Update Featured Image
    // ----------------------------------

    function updateFeatured(index){

        featured.src = gallery[index].src;
        featured.srcset = "";
        featured.alt = gallery[index].alt;

        thumbs.forEach((thumb,i)=>{
            thumb.classList.toggle("is-active",i===index);
        });

    }

    // ----------------------------------
    // Slide Modal
    // ----------------------------------

    function slideTo(index){

        if(index<0){
            index=gallery.length-1;
        }

        if(index>=gallery.length){
            index=0;
        }

        currentIndex=index;

        track.style.transform=`translateX(-${index*100}%)`;

        updateFeatured(index);

    }

    // ----------------------------------
    // Open Modal
    // ----------------------------------

    function openModal(){

        modal.hidden=false;

        document.body.style.overflow="hidden";

        const active=document.querySelector(".nini-thumb.is-active");

        currentIndex=active
            ? Number(active.dataset.index)
            : 0;

        slideTo(currentIndex);

    }

    function closeModal(){

        modal.hidden=true;

        document.body.style.overflow="";

    }

    // ----------------------------------
    // Featured Click
    // ----------------------------------

    featured.style.cursor="zoom-in";

    featured.addEventListener("click",openModal);

    // ----------------------------------
    // Thumbnail Click
    // ----------------------------------

    thumbs.forEach((thumb,index)=>{

        thumb.dataset.index=index;

        thumb.addEventListener("click",()=>{

            slideTo(index);

        });

    });

    // ----------------------------------
    // Next
    // ----------------------------------

    nextBtn.addEventListener("click",()=>{

        slideTo(currentIndex+1);

    });

    // ----------------------------------
    // Previous
    // ----------------------------------

    prevBtn.addEventListener("click",()=>{

        slideTo(currentIndex-1);

    });

    // ----------------------------------
    // Close
    // ----------------------------------

    closeBtn.addEventListener("click",closeModal);

    modal.addEventListener("click",(e)=>{

        if(e.target===modal){

            closeModal();

        }

    });

    // ----------------------------------
    // Keyboard
    // ----------------------------------

    document.addEventListener("keydown",(e)=>{

        if(modal.hidden) return;

        switch(e.key){

            case "ArrowRight":
                slideTo(currentIndex+1);
                break;

            case "ArrowLeft":
                slideTo(currentIndex-1);
                break;

            case "Escape":
                closeModal();
                break;

        }

    });

});